export enum PropertyInformationInputLabel {
  MonthlyMortgage = 'Monthly Mortgage',
}

export enum PropertyInformationFieldName {
  MonthlyMortgage = 'monthlyMortgage',
}
